import googleCertificateExperiments from 'bundles/epic/clients/GoogleCertificate';

import _t from 'i18n!nls/enroll';

export const isFreemiumModelEnabled = () => googleCertificateExperiments.preview('isFreemiumModelEnabled');

export const useIsEnrolledThroughFreemiumAccess = () => {
  // TODO replace with actual logic from BE
  return (
    isFreemiumModelEnabled() &&
    typeof window !== 'undefined' &&
    window.location.search.includes('isEnrolledThroughFreemiumAccess')
  );
};

// TODO update description copies once they are finalized
export const getFreemiumEnrollModalCopy = () => ({
  auditOnly: _t('Preview this course'),
  auditOnlyDescription: _t('You will have access to all course materials except graded items'),
  fullCourseNoCertificate: _t('Preview this course'),
  fullCourseNoCertificateDescription: _t('You will still have access to all course materials for this course'),
});
